/**
 * For when you want to just deal with a single type of constituent (like doc viewer)
 * @class
 */
import Base from '@netx/core/lib/netx-collection';

export default class AssetConstituents_ extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {boolean} */
	get xhrTrackProgress() {
		return true;
	}

	/**
	 * @property {object}  methods       - Collection RPC methods
	 * @property {method}  methods.read  - Fetch constituents
	 */
	get methods() {
		return {
			/** @method */
			read: ['getConstituentsForAsset', 'assetId'],
		};
	}

	/**
	 * @property {object}   parsers       - Collection parsers
	 * @property {function} parsers.read  - Parse the results of fetch
	 */
	get parsers() {
		return {
			/**
			 * @function
			 * @param {array} data Data
			 * @param {object} opts Request options
			 */
			read(data, opts) {
				// Where k could be
				// clips
				// keyframes
				// layers
				// pages
				_.each(data, (v, k) => {
					if (k === this.type) {
						this.reset(v);
						this['original' + _.ucfirst(k)] = v.slice();
					}
					delete data[k];
				});
				// Return nothing - not doing so will result in rpc setting the return for us
				return null;
			},
		};
	}

	constructor(models, options) {
		super(models, options);

		this.asset = options.asset || null;

	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituents_';
	}
}
